export const SET_PRODUCT = "internalProduct/SET_PRODUCT";
export const ADD_PRODUCT = "internalProduct/ADD_PRODUCT";
export const CLEAR = "internalProduct/CLEAR";
